import { useHistory } from "react-router";
import toast from "react-hot-toast";

import inviteImage from "@/img/invite_confirm_switch_teams.png";
import { makeRequest } from "@/util";
import { Button } from "@/design-system/components/Button/Button";
import { TopBar } from "@/Topbar/TopBar";
import { ConfirmSwitchTeamProps } from "./types";
import { AcceptInvitePageWrapper } from "./utils";

export function ConfirmSwitchTeams({
  onConfirm,
  inviteID,
  fromEmail,
}: ConfirmSwitchTeamProps) {
  const history = useHistory();

  const handleDecline = async () => {
    try {
      await makeRequest("decline_invite", { invite_id: inviteID });
      history.push("/events");
    } catch (e) {
      toast.error("Something went wrong. Unable to decline invite.");
      console.error(e);
    }
  };

  return (
    // TODO[IND-1682]: TopBar calls useUsers hook which will auto instantiate
    // an account for the email, even when in the accept invite flow. This results
    // in an orphaned account being created.
    <>
      <TopBar includeLogo />
      <AcceptInvitePageWrapper>
        <img alt="" src={inviteImage} />
        <h1>Join Organization</h1>
        <p>
          You have received a pending invite
          {fromEmail && " from " + fromEmail} to a different account. Any data
          in your existing account will be lost. Would you like to accept the
          invite?
        </p>
        <div className="flex gap-4">
          <Button variant="secondary" onClick={handleDecline}>
            Decline
          </Button>
          <Button onClick={onConfirm}>Accept</Button>
        </div>
      </AcceptInvitePageWrapper>
    </>
  );
}
